import React from 'react';

export const FormRow = ({ children, className = '', size = 1 }) => {
	return (
		<div className={`form-row ${className}`} style={{ flex: size }}>
			{children}
		</div>
	);
};
